import i18n from 'i18next';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentRoutingTypes } from '../../hooks';

export const ShipmentRoutingTypesSelect = ({
  placeholder = i18n.t('translation:default.fields.routingType.placeholder'),
  label = i18n.t('translation:default.fields.routingType.label'),
  rules = [],
  name,
  editMode,
  value,
  tooltip,
  margin = 'mb-0',
}) => {
  const { data: options = [], isLoading } = useGetShipmentRoutingTypes();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      value={value}
      tooltip={tooltip}
    />
  );
};
